import { useQuery } from 'react-query';

import { useConfig } from '../components/ConfigContext';
import { load, isSpecial } from '../lib';

const loadStandings = (filters, querySort, queryOrder, apiUrl) => {
  const { scheduleId, groupId } = filters;

  let order = ['group.name ASC', 'ranking ASC'];
  if (querySort && queryOrder) {
    const rankingOrder = (queryOrder == 'ASC') ? 'DESC' : 'ASC';
    order = ['group.name ASC', `${querySort} ${queryOrder}`, `ranking ${rankingOrder}`];
  }

  const query = {
    include: 'team',
    order,
  }

  if (groupId) {
    query.where = { groupId }
  }

  const request = load(`${apiUrl}/schedules/${scheduleId}/teamStats`, {
    filter: query,
  })
  const result = request.then(standings => standings.filter(stat => stat && !isSpecial(stat.team)))

  result.cancel = request.cancel;
  return result;
}

export const useStandings = (filters, querySort, queryOrder, options) => {
  const { apiUrl } = useConfig();

  return useQuery(
    ['standings-data', filters, querySort, queryOrder],
    () => loadStandings(filters, querySort, queryOrder, apiUrl),
    { enabled: !!filters?.scheduleId, ...options }
  )
}
